<template>
<v-app id="login" light>
  <v-layout style="margin-top:1em;">
    <v-flex v-if="!splashScreen">
      <v-hover>
        <template v-slot:default="{ hover }">
          <v-card :elevation="hover ? 12 : 6" class="pa-2 mx-auto rounded-xl transition-swing" style="max-width: 400px;">
            <v-card-title >
              <v-img :src='images.logoSmall' contain class="mx-auto" :aspect-ratio="16/10" alt='logo'></v-img>
            </v-card-title>
            <v-card-text>
                Tentative de connexion en cours...
              <v-progress-linear v-show="valid" :indeterminate="true"></v-progress-linear>
            </v-card-text>
            <v-card-actions>
              <v-btn v-if="valid" class="elevation-1" 
                href="#/login" color="primary" light block>
                Se connecter avec mon login
              </v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-hover>
    </v-flex>
    <v-flex v-if="splashScreen" class="mt-1">
      <v-row align="center" justify="center">
        <v-img :src='images.logoSmall' alt='logo' max-height="150" contain></v-img>
      </v-row>
      <div class="text-center text-h2 font-weight-bold mt-9">Chargement des données</div>
      <v-progress-linear v-if="splashScreen" :indeterminate="true"></v-progress-linear>
    </v-flex>
  </v-layout>
</v-app>
</template>

<script>
import { actions, state } from "@/stores/auth.module"

export default {
  name: 'login-component',
  data () {
    return {
      checkAuth: false,
      badAuth: false,
      errorMessage: [],
      formData : {
        login: '',
        password: '',
        persist: false,
        _path: 'auth',
        _method: 'GET'
      },
      valid: true,
      nameRules: [ (v) => !!v || 'Identifiant obligatoire' ],
      passRules: [ (v) => !!v || 'Pass obligatoire' ],
      images: {
        logoSmall: require('@/assets/logo.svg')
      },
      message: 'Tentative de connexion en cours...',
      oAuth: false, splashScreen: false
    }
  },
  computed: {
      loginControl() {
        return state.authenticating
      },
  },
  mounted:function (){
      if( ( this.$route.params.token ) && this.$route.params.token.length > 3 ){
        actions.loginWithToken({magicToken: this.$route.params.token, grant_type: 'token'}) //authorization_code
        setTimeout(() => {
          this.valid = true
          this.message = 'Lien non valide ou expiré'
        }, 1000)
      } else {
        setTimeout(() => {
          this.valid = true
          this.message = 'Lien non valide ou expiré'
        }, 1000)
      }
  },
  methods: {

  }
}
</script>

<style lang="css">
/* Personnalisation code */
.login-container {
  transform: translate(0, -50px);
  padding-top: 2em;
}
.login-paper {
  width: 24em;
  text-align: center;
  margin-right: auto;
  margin-left: auto;
}
.login-logo {
  margin-bottom: 1.2em;
  padding-top: 0.5em;
}

</style>